const kfgyltj = () => import('../modules/xmsb/cxzcsd/kfgyltj')
const BusinessInfoPage = () => import('../modules/xmsb/cxzcsd/BusinessInfoPage')

export default [
  {
    path: '/xmsb/cxzcsd/kfgyltj',
    name: 'kfgyltj',
    component: kfgyltj,
    meta: {
      title: '支持产业链强链稳链项目审核',
    },
  },
  {
    path: '/xmsb/cxzcsd/BusinessInfoPage',
    name: 'BusinessInfoPage',
    component: BusinessInfoPage,
    meta: {
      title: '支持产业链强链稳链项目供应链开放情况数据',
    },
  },

]
